// Common Google Business Profile (GMB) categories used across prospecting & lead forms.
export const GOOGLE_BUSINESS_CATEGORIES = [
  // Home & Local Services
  "Plumber", "HVAC Contractor", "Roofing Contractor", "Electrician", "Landscaper",
  "General Contractor", "Pest Control Service", "House Cleaning Service", "Moving Company",
  "Painter", "Locksmith", "Garage Door Service", "Pool Cleaning Service", "Handyman",
  "Tree Service",
  // Automotive
  "Auto Repair Shop", "Car Dealer", "Auto Body Shop", "Tire Shop", "Car Wash",
  // Health & Medical
  "Dentist", "Doctor", "Chiropractor", "Veterinarian", "Optometrist",
  "Physical Therapist", "Dermatologist", "Pharmacy", "Medical Spa",
  // Professional Services
  "Lawyer", "Accountant", "Insurance Agency", "Real Estate Agency", "Marketing Agency",
  "Financial Planner", "Architect", "Notary", "Staffing Agency",
  // Food & Drink
  "Restaurant", "Cafe", "Bakery", "Bar", "Coffee Shop", "Pizza Restaurant",
  "Catering Service", "Food Truck",
  // Beauty & Wellness
  "Hair Salon", "Nail Salon", "Spa", "Barber Shop", "Massage Therapist", "Tattoo Shop",
  // Fitness & Recreation
  "Gym", "Yoga Studio", "Personal Trainer", "Martial Arts School", "Dance Studio",
  // Retail
  "Clothing Store", "Furniture Store", "Jewelry Store", "Florist", "Pet Store",
  "Hardware Store",
  // Education & Childcare
  "Preschool", "Tutoring Service", "Driving School", "Daycare",
  // Events & Other
  "Photographer", "Event Planner", "Wedding Venue", "DJ Service",
];
